import React from 'react';
import {Box} from '@mui/material';
import {ReportPackFragment} from '../../schema-types/ReportPackFragment';

import {ContactBasicFragment} from '../../schema-types/ContactBasicFragment';
import {
  ReportPackFormStatus,
  ReportPackStatus,
  ReportPackTemplateTypes,
} from '../../schema-types/globalTypes';
import {themeColors} from '../../theme/Theme';

import {ColoredChip} from '../../components/EditorGrid/GridRenderComponents';
import validateUUID from '../../utils/validateUUID';

export const isValidReviewId = (reviewId: string | null | undefined): boolean =>
  validateUUID(reviewId) !== null;

export const shouldStartSmartflowPolling = (
  reviewId: string | null | undefined,
  report: ReportPackFragment,
  isPolling: boolean
): boolean =>
  !isPolling &&
  isValidReviewId(reviewId) &&
  !!report.smartflowExecution &&
  report.smartflowExecution.status !== 'complete';

export type ReportPackContactProps = {
  contact: ContactBasicFragment;
  report: ReportPackFragment;
};

export const FormStatus: React.FC<{formStatus: ReportPackFormStatus}> = ({
  formStatus,
}) => {
  const statusToColor: Record<ReportPackFormStatus, string> = {
    IN_PROGRESS: themeColors.lightYellow,
    COMPLETED: themeColors.lightGreen, // this was READY_TO_SUBMIT before
  };
  return (
    <Box>
      <ColoredChip
        colorScheme={statusToColor}
        value={formStatus === ReportPackFormStatus.COMPLETED ? 'Uploaded' : formStatus}
        colorKey={formStatus}
      />
    </Box>
  );
};

export const ReportPackStatusColourScheme: Record<ReportPackStatus, string> = {
  [ReportPackStatus.IN_PROGRESS]: themeColors.lightYellow,
  [ReportPackStatus.READY_TO_SUBMIT]: themeColors.lightGreen,
  [ReportPackStatus.SUBMITTED]: themeColors.lightBlue,
  [ReportPackStatus.PARTLY_SIGNED]: themeColors.lightPurple,
  [ReportPackStatus.SIGNED]: themeColors.lightPurple,
  [ReportPackStatus.CANCELLED]: themeColors.lightAlert,
  [ReportPackStatus.EXPIRED]: themeColors.lightAlert,
  [ReportPackStatus.NO_LONGER_NEEDED]: themeColors.lightAlert,
  [ReportPackStatus.PARTLY_READ]: themeColors.lightBlue,
  [ReportPackStatus.READ]: themeColors.lightPurple,
};

export interface UploadDocumentFormType {
  files?: File[];
  selectedGenericForms?: string[];
}

export const getReportPackDisabled = (report: ReportPackFragment) => {
  if (!report.isEditable) {
    return true;
  }
  if (
    report.status === ReportPackStatus.READY_TO_SUBMIT ||
    report.status === ReportPackStatus.IN_PROGRESS
  ) {
    return false;
  }
  return true;
};

export const getReportPackLetterTitle = (
  template: ReportPackTemplateTypes | null | undefined
): string => {
  if (template === ReportPackTemplateTypes.NO_ACTION_LETTER) {
    return 'No Action letter';
  }
  if (template === ReportPackTemplateTypes.DECLINED_LETTER) {
    return 'Declined letter';
  }
  if (template === ReportPackTemplateTypes.UNCONTACTABLE_LETTER) {
    return 'Uncontactable letter';
  }
  return '';
};
